var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.00001 11.3035V8.63688M8.00001 5.97021H8.00668M14.6667 8.63688C14.6667 12.3188 11.6819 15.3035 8.00001 15.3035C4.31811 15.3035 1.33334 12.3188 1.33334 8.63688C1.33334 4.95498 4.31811 1.97021 8.00001 1.97021C11.6819 1.97021 14.6667 4.95498 14.6667 8.63688Z",
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.f2139d9b8127329373688e4f5e4b3394.svg";
export { ForwardRef as ReactComponent };